import { HttpParams } from '@angular/common/http'
import { RequestParams } from '../types/request-params'

export function buildRequestParams(
  params: HttpParams,
  data: RequestParams,
  currentPath: string
) {
  Object.keys(data).forEach((key) => {
    if (data[key] instanceof Object) {
      params = buildRequestParams(
        params,
        data[key] as RequestParams,
        currentPath ? `${currentPath}[${key}]` : key
      )
    } else {
      if (data[key] !== undefined) {
        params = params.set(
          currentPath ? `${currentPath}[${key}]` : key,
          `${data[key]}`
        )
      }
    }
  })
  return params
}
